import { useEffect } from 'react'

import { FollowUpQuestions } from '../follow-up-questions'
import { StaticChatInput, StaticChatInputProps } from '../static-chat-input'
import { StaticChatMessages, StaticChatMessagesProps } from '../static-chat-messages'
import { StaticChatTopbar } from '../static-chat-topbar'
import styles from './thesis-chat-layout.module.scss'

export interface ThesisChatLayoutProps {
  messages: StaticChatMessagesProps['messages']
  clusterId: string
  onDisplayMessages?: StaticChatMessagesProps['onDisplayMessages']
  onSubmitInput?: StaticChatInputProps['onSubmitInput']
  clusterLabel: string
}

export function ThesisChatLayout(props: ThesisChatLayoutProps) {
  const { messages, clusterId, onDisplayMessages, onSubmitInput, clusterLabel } = props

  useEffect(() => {
    document.documentElement.classList.add(styles.html)
    return () => {
      document.documentElement.classList.remove(styles.html)
    }
  }, [])

  return (
    <div className={styles.container}>
      <StaticChatTopbar />
      <main className={styles.main}>
        <div className={styles.messagesContainer}>
          <StaticChatMessages messages={messages} onDisplayMessages={onDisplayMessages} />
        </div>
        <div className={styles.followUpQuestionsContainer}>
          <FollowUpQuestions clusterId={clusterId} clusterLabel={clusterLabel} />
        </div>
      </main>
      <div className={styles.chatInputContainer}>
        <StaticChatInput onSubmitInput={onSubmitInput} clusterLabel={clusterLabel} />
      </div>
    </div>
  )
}
